import React, { useState } from 'react';
import { Slider } from '@/components/ui/slider';

// Sale Toggle Component - Inline checkbox + slider
const SaleToggle = ({ price, salePrice, onSaleChange, compact = false }) => {
  const [isOnSale, setIsOnSale] = useState(salePrice && salePrice < price);
  const [salePercent, setSalePercent] = useState(() => {
    if (salePrice && salePrice < price) {
      return Math.round((1 - salePrice / price) * 100 / 5) * 5;
    }
    return 10;
  });

  const handleToggle = (checked) => {
    setIsOnSale(checked);
    if (checked) {
      const newSalePrice = price * (1 - salePercent / 100);
      onSaleChange(Math.round(newSalePrice * 100) / 100);
    } else {
      onSaleChange(null);
    }
  };

  const handleSliderChange = (value) => {
    const percent = value[0];
    setSalePercent(percent);
    if (isOnSale) {
      const newSalePrice = price * (1 - percent / 100);
      onSaleChange(Math.round(newSalePrice * 100) / 100);
    }
  };

  const calculatedSalePrice = price * (1 - salePercent / 100);

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        <label className="flex items-center gap-1.5 cursor-pointer">
          <input
            type="checkbox"
            checked={isOnSale}
            onChange={(e) => handleToggle(e.target.checked)}
            className="w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary"
          />
          <span className="text-xs font-medium whitespace-nowrap">ON SALE</span>
        </label>
        <div className={`flex items-center gap-2 transition-opacity ${isOnSale ? 'opacity-100' : 'opacity-30 pointer-events-none'}`}>
          <Slider
            value={[salePercent]}
            onValueChange={handleSliderChange}
            min={5}
            max={75}
            step={5}
            className="w-20"
          />
          <span className={`text-xs font-bold w-10 ${isOnSale ? 'text-red-600' : 'text-gray-400'}`}>
            {salePercent}% off
          </span>
        </div>
        {isOnSale && (
          <span className="text-xs text-green-600 font-medium">
            → ${calculatedSalePrice.toFixed(2)}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={isOnSale}
            onChange={(e) => handleToggle(e.target.checked)}
            className="w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary"
          />
          <span className="text-sm font-medium">ON SALE</span>
        </label>
        
        <div className={`flex items-center gap-3 flex-1 transition-opacity ${isOnSale ? 'opacity-100' : 'opacity-30 pointer-events-none'}`}>
          <Slider
            value={[salePercent]}
            onValueChange={handleSliderChange}
            min={5}
            max={75}
            step={5}
            className="flex-1 max-w-[200px]"
          />
          <span className={`text-sm font-bold min-w-[60px] ${isOnSale ? 'text-red-600' : 'text-gray-400'}`}>
            {salePercent}% off
          </span>
        </div>
      </div>
      
      {isOnSale && (
        <div className="flex items-center gap-2 text-sm">
          <span className="text-muted-foreground line-through">${price.toFixed(2)}</span>
          <span className="text-green-600 font-bold">→ ${calculatedSalePrice.toFixed(2)}</span>
          <span className="text-xs bg-red-100 text-red-700 px-1.5 py-0.5 rounded">SAVE ${(price - calculatedSalePrice).toFixed(2)}</span>
        </div>
      )}
    </div>
  );
};

export default SaleToggle;
